import React, { useEffect, useState } from 'react';
import classes from "./MatchLayoutForPrediction.module.css";
import moment from 'moment-timezone';
import { useNavigate } from 'react-router-dom';
import { FaCircle, FaMinus } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const FT_STATUSES   = ["FT","AET","PEN"];
const LIVE_STATUSES = ["1H","2H","ET","P","HT","LIVE"];

const renderStatus = (match_details, classes,t) => {
    const short   = match_details?.fixture?.status?.short;
    const elapsed = match_details?.fixture?.status?.elapsed;
    const extra   = match_details?.fixture?.status?.extra;

    if (FT_STATUSES.includes(short))          return <span className={classes.status_text}>{t("87")}</span>;
    if (short === "SUSP")                     return <span className={classes.status_text}>{t("88")}</span>;
    if (short === "PST")                      return <span className={classes.status_text}>{t("89")}</span>;
    if (short === "CANC")                     return <span className={classes.status_text}>{t("90")}</span>;
    if (["ABD","AWD","WO"].includes(short))   return <span className={classes.status_text}>{t("91")}</span>;
    if (short === "HT")  return <span className={classes.status_text}><FaCircle className={`${classes.text_danger_glow} ${classes.blink}`} style={{ fontSize: 8, marginRight: 6 }} />{t("92")} {elapsed}`</span>;
    if (short === "ET")  return <span className={classes.status_text}><FaCircle className={`${classes.text_danger_glow} ${classes.blink}`} style={{ fontSize: 8, marginRight: 6 }} />{elapsed}` ET +{extra}`</span>;
    if (short === "P")   return <span className={classes.status_text}><FaCircle className={`${classes.text_danger_glow} ${classes.blink}`} style={{ fontSize: 8, marginRight: 6 }} />{t("93")} {elapsed}`</span>;
    if (["1H","2H","LIVE"].includes(short))   return <span className={classes.status_text}><FaCircle className={`${classes.text_danger_glow} ${classes.blink}`} style={{ fontSize: 8, marginRight: 6 }} />{elapsed}`</span>;
    return null;
};

const MatchLayoutForPrediction = ({ match, match_details, key, index }) => {
    const navigate = useNavigate();
    const [time, setTime] = useState(null);
    const [display, setDisplay] = useState("block");

    const { selectedLanguage } = useSelector((state) => state.languageSlice);

    const [status,setStatus]=useState(null);

    const {t}=useTranslation();

    const matchTimer = (match_date_time) => {
        try {
            const liveTime = moment();
            const matchTime = moment.utc(match_date_time);
            const timeLeft = moment.duration(matchTime.diff(liveTime));
            if (timeLeft.asMilliseconds() <= 0) setDisplay("none");
            const hours = Math.floor(timeLeft.asHours());
            const minutes = timeLeft.minutes();
            const seconds = timeLeft.seconds();
            setTime(`${hours}h ${minutes}m ${seconds}s`);
        } catch (error) { console.log(error); }
    };

    useEffect(() => {
        if (display !== "none") {
            const id = setInterval(() => matchTimer(match?.match_date_time), 1000);
            return () => clearInterval(id);
        }
    }, [display]);

    const short = match_details?.fixture?.status?.short;
    const showScore = [...FT_STATUSES, ...LIVE_STATUSES].includes(short);

    useEffect(()=>{
            setStatus(()=>renderStatus(match_details,classes,t));
    },[selectedLanguage,t]);

    // const status = renderStatus(match_details, classes);

    return (
        <div className={classes.match_container} key={key} style={{ animationDelay: `${(index ?? 0) * 0.07}s` }}>
            <div className={classes.match_heading}>
                <p className={classes.match_title}>{match?.league_name}</p>
            </div>

            {status && <div className={classes.match_status}>{status}</div>}

            <div className={classes.match_sub_container}>
                <div className={classes.match_details}>
                    <img src={match?.home_team_image} alt={match?.home_team_name} className={classes.team_logo} />
                    <p className={classes.team_name}>{match?.home_team_name}</p>
                </div>

                {showScore ? (
                    <div className={classes.score_container}>
                        <span className={classes.score}>{match_details?.goals?.home ?? "-"}</span>
                        <div className={classes.separator}><FaMinus className={classes.separator_icon} /></div>
                        <span className={classes.score}>{match_details?.goals?.away ?? "-"}</span>
                    </div>
                ) : match?.match_status === "NS" ? (
                    <div className={classes.match_details}>
                        <p className={classes.match_timer} style={{ display }}>⏱ {time}</p>
                        <p className={classes.match_time}>{moment.utc(match?.match_date_time).local().format("ddd, DD MMM [at] hh:mm A")}</p>
                    </div>
                ) : null}

                <div className={classes.match_details}>
                    <img src={match?.away_team_image} alt={match?.away_team_name} className={classes.team_logo} />
                    <p className={classes.team_name}>{match?.away_team_name}</p>
                </div>
            </div>

            <p className={classes.match_time} style={{ textAlign: "center", width: "100%", padding: "0 14px 4px" }}>
                {moment.utc(match?.match_date_time).local().format("dddd, DD MMM YYYY [at] hh:mm A")}
            </p>

            <div className={classes.buttons_container}>
                <button
                    type="button"
                    className={classes.prediction_button}
                    onClick={() => navigate("/prediction-game", { state: { match_fixture_id: match?.match_fixture_id } })}
                >
                    {match?.match_status === "Match Finished" ? t("209") : t("210")}
                </button>
            </div>
        </div>
    );
};

export default MatchLayoutForPrediction;